import { render, staticRenderFns } from "./df-section-banner.vue?vue&type=template&id=62ced23c"
import script from "./df-section-banner.ts?vue&type=script&lang=js&external"
export * from "./df-section-banner.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports